import * as React from "react"
import { Link } from "react-router-dom"
import { Action, mk_widget, Widget } from "widgets-for-react"
import { isResetPasswordRequestState, LoginState, ResetPasswordRequestState } from "../state"
import { notifications } from '../notifications';
import { Api } from '../api_to_state';
import { MinimalLoginWidgetData, update_state_with_route } from "../login";
import { LoginFlowStyle, LoginFlowClasses } from "./style.mod";
import { getClassName } from "../../utils/utils.mod";
import i18next = require("i18next");

function handleSubmit<a, extra_user_info>(e: React.FormEvent<HTMLFormElement>, setState: (_: Action<LoginState<a, extra_user_info>>) => void, api: Api<extra_user_info>) {
  e.preventDefault();
  setState(s => isResetPasswordRequestState(s)
    ? (api && api.isValidEmail && api.isValidEmail(s.login_data.email!)
      ? ({ status: "reset password request - resetting", login_data: s.login_data })
      : { ...s, login_data: { ...s.login_data, email: s.login_data.email == undefined ? "" : s.login_data.email } })
    : s);
}

export function reset_password_request_form<a, extra_user_info>(
  data: MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) {
  return (s0: ResetPasswordRequestState, readonly: boolean, rootpath: string, api?: Api<extra_user_info>): Widget<Action<LoginState<a, extra_user_info>>> => {
    let email_error = (s0.login_data.email != undefined && !(api && api.isValidEmail && api.isValidEmail(s0.login_data.email)));

    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-reset-password-request-form">
            <header className={getClassName(options, "header_classname", "mb-4")}>
              <Link className="header__link" to={`${rootpath}`}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>{i18next.t(`loginflow:reset_password_request.title`)}</h1>
                <svg className="header__logo" width="120" height="32" aria-hidden="true">
                  <use xlinkHref="#icon--logo" />
                </svg>
              </Link>
            </header>

            <div className={getClassName(options, "inner_classname", "py-5")}>
              <form onSubmit={(e) => handleSubmit(e, setState, api)} className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>

                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="email"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      {i18next.t(`loginflow:reset_password_request.fields.email`)}
                    </label>
                    <input
                      type="text"
                      name="email"
                      id="email"
                      aria-invalid={email_error}
                      aria-describedby={email_error ? "a11y-email-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${email_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.email}
                      disabled={readonly}
                      onChange={(event) => setState(s => isResetPasswordRequestState(s) ? ({
                        ...s,
                        status: "reset password request",
                        login_data: {
                          ...s.login_data,
                          email: event.currentTarget.value
                        }
                      }) : s)
                      }
                    />
                    {email_error && (
                      <p id="a11y-email-error" className={getClassName(options, "form_error_classname", "invalid-feedback d-block")}>
                        {i18next.t(`loginflow:reset_password_request.fields.email_invalid`)}
                      </p>
                    )}
                  </div>

                  {notifications(s0, { style: LoginFlowClasses }).run(() => s => s)}

                  <div className={getClassName(options, "form_actions_classname", "")}>
                    <button
                      type="submit"
                      className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                      disabled={readonly}
                    >
                      {i18next.t(`loginflow:reset_password_request.clickables.submit`)}
                    </button>
                  </div>

                  <div className={getClassName(options, "footer_classname", "")}>
                    {data.without_browserRouter
                      ? <button
                        type="button"
                        className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                        onClick={() => setState(update_state_with_route({ kind: "home" }, data))}
                      >
                        {i18next.t(`loginflow:reset_password_request.clickables.cancel`)}
                      </button>
                      : <Link
                        to={rootpath}
                        className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                      >
                        {i18next.t(`loginflow:reset_password_request.clickables.cancel`)}
                      </Link>
                    }
                  </div>
                </div>
              </form>
            </div>
          </section>
        )
      }
    })
  }
}

export function reset_password_request_success<a, extra_user_info>(
  data: MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) {
  return (s0: ResetPasswordRequestState, rootpath: string): Widget<Action<LoginState<a, extra_user_info>>> => {
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-reset-password-request-success">
            <header className={getClassName(options, "header_classname", "mb-4")}>
              <Link className="header__link" to={`${rootpath}`}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>{i18next.t(`loginflow:reset_password_request_success.title`)}</h1>
                <svg className="header__logo" width="120" height="32" aria-hidden="true">
                  <use xlinkHref="#icon--logo" />
                </svg>
              </Link>
            </header>

            <div className={getClassName(options, "inner_classname", "py-5")}>
              <div className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>
                  <p
                    className={getClassName(options, "intro_classname", "lead")}
                    dangerouslySetInnerHTML={
                      { __html: i18next.t(`loginflow:reset_password_request_success.text_a`, { email: `<b>${s0.login_data.email}</b>`, interpolation: { escapeValue: false } }) }
                    }
                  />
                  <p
                    className={getClassName(options, "intro_classname", "")}
                    dangerouslySetInnerHTML={
                      { __html: i18next.t(`loginflow:reset_password_request_success.text_b`, { email: `<a href="mailto:info@boonedam.com">info@boonedam.com</a>`, interpolation: { escapeValue: false } }) }
                    }
                  />
    
                  <footer className={getClassName(options, "form_actions_classname", "")}>
                    {data.without_browserRouter
                      ? <button
                        type="button"
                        className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                        onClick={() => setState(update_state_with_route({ kind: "home" }, data))}
                      >
                        {i18next.t(`loginflow:reset_password_request_success.clickables.cancel`)}
                      </button>
                      : <Link
                        to={rootpath}
                        key="reset_pass_success_signin"
                        className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                      >
                        {i18next.t(`loginflow:reset_password_request_success.clickables.cancel`)}
                      </Link>
                    }
                  </footer>
                </div>
              </div>
            </div>
          </section>
        )
      }
    })
  }
}